export { default as IdentityDocumentPhotoGuide } from './IdentityDocumentPhotoGuide';
